
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

import { ResponseBase } from '../models/response-base';
import { SolicitacoesResponseModel } from '../models/response/solicitacoes-response-model';
import { SolicitacoesRequestModel } from '../models/request/solicitacoes-request-model';
import { IntencaoDepositoRequestModel } from '../models/request/intencao-deposito-request-model';
import { IntencaoDepositoResponseModel } from '../models/response/intencao-deposito-response-model';
import { IntencaoConsultaRequestModel } from '../models/request/intencao-consulta-request-model';
import { IntencaoConsultaResponseModel } from '../models/response/intencao-consulta-response-model';
import { DepositoViaBoletoRequestModel, DepositoViaPIXRequestModel } from '../models/request/deposito-via-boleto-request-model';
import { UploadComprovanteRequestModel } from '../models/request/upload-comprovante-request-model';
import { GerarPixDinamico } from '../models/request/gerar-pix-dinamico';
import { QRCodePixDinamico } from '../models/response/pix-qrcode';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {

    private API: string = environment.API + 'Transaction';

    constructor(private http: HttpClient) { }

    BuscarSolicitacoes(solicitacoesRequestModel: SolicitacoesRequestModel): Observable<ResponseBase<SolicitacoesResponseModel[]>> {
        return this.http.post<ResponseBase<SolicitacoesResponseModel[]>>(`${this.API}/solicitacoes`, solicitacoesRequestModel);
    }

    ObterDeposito(intencaoConsultaRequestModel: IntencaoConsultaRequestModel): Observable<ResponseBase<IntencaoConsultaResponseModel[]>> {
        return this.http.post<ResponseBase<IntencaoConsultaResponseModel[]>>(`${this.API}/intencaodeposito/consulta`, intencaoConsultaRequestModel);
    }

    CriarDeposito(intencaoDepositoRequestModel: IntencaoDepositoRequestModel): Observable<ResponseBase<IntencaoDepositoResponseModel>> {
        return this.http.post<ResponseBase<IntencaoDepositoResponseModel>>(`${this.API}/intencaodeposito/cadastrar`, intencaoDepositoRequestModel);
    }

    CancelarDeposito(depositoID: string, gestorGuid: string): Observable<ResponseBase<IntencaoDepositoResponseModel>> {
        return this.http.delete<ResponseBase<IntencaoDepositoResponseModel>>(`${this.API}/intencaodeposito/cancelar/${depositoID}/gestor/${gestorGuid}`);
    }

    CriarDepositoViaBoleto(depositoViaBoletoRequestModel: DepositoViaBoletoRequestModel): Observable<ResponseBase<string>> {
        return this.http.post<ResponseBase<string>>(`${this.API}/deposito/boleto/cadastrar`, depositoViaBoletoRequestModel);
    }
    CriarDepositoViaPix(depositoViaPIXRequestModel: DepositoViaPIXRequestModel): Observable<ResponseBase<string>> {
        return this.http.post<ResponseBase<string>>(`${this.API}/deposito/pix/cadastrar`, depositoViaPIXRequestModel);
    }
    
    UploadComprovanteDeposito(uploadComprovanteRequestModel: UploadComprovanteRequestModel): Observable<ResponseBase<string>> {
        return this.http.post<ResponseBase<string>>(`${this.API}/comprovantedeposito/upload`, uploadComprovanteRequestModel);
    }
    GerarPixDinamico(pixDinamicoRequestModel: GerarPixDinamico): Observable<ResponseBase<QRCodePixDinamico>> {
        return this.http.post<ResponseBase<QRCodePixDinamico>>(`${this.API}/qrcode/gerarpixdinamico`, pixDinamicoRequestModel);
    }
}